import React from 'react';

import { Page } from "src/pages/_partials/Layout";
import NavBar2 from 'src/componets/NavBar2';
import { isActiveUrl } from "src/helpers/UrlHelpers";
import { useLocation } from "react-router-dom";

interface PropsInterface {
  className?: string;
  children: React.ReactNode;
  navs?: any;
}

const PageLayout: React.FC<PropsInterface> = (props) => {
  const { pathname } = useLocation();
  const ids = props.navs ? Object.keys(props.navs).map(id => parseInt(id, 10)) : [];
  const pageId = ids.find(id => isActiveUrl(props.navs[id].url, pathname));

  return (
    <Page className={props.className}>
      {props.navs && <NavBar2 items={props.navs} itemIds={ids} activeId={pageId} /> }

      <div className='v-layout--body'>
        {props.children}
      </div>
     </Page>
  );
}

export default PageLayout;
